<template>
  <div id="asider-wrapper">
    <div class="asider-icon">
      <div></div>
    </div>
    <!-- 左边导航栏颜色  background-color="#f78989"-->
    <!-- <el-menu :default-active="indexPath" :default-openeds="openeds" :unique-opened='true' style='background: rgb(48, 65, 86);' class="el-menu-vertical-demo max-height-95" @select="open" @open="handleOpen" @close="handleClose" :collapse="collapse" active-text-color="#5e9af5" text-color="white">
      <router-link v-for="(item,index) in  roomList" :key="index" :to="item.route"  tag="p">
        <el-menu-item :index="item.index" v-role="item.number">
          <i :class="item.icon"></i>
          <span slot="title">{{ item.name }}</span>
        </el-menu-item>
      </router-link>

    </el-menu> -->
    <el-menu
      :default-active="indexPath"
      :default-openeds="openeds"
      :unique-opened="true"
      style="background: rgb(48, 65, 86)"
      class="el-menu-vertical-demo max-height-95"
      @select="open"
      @open="handleOpen"
      @close="handleClose"
      :collapse="collapse"
      active-text-color="#5e9af5"
      text-color="white"
    >
      <template v-for="(item, index) in roomList">
        <!-- If item has children, render el-submenu -->
        <el-submenu v-if="item.children" :index="item.index" :key="index">
          <template slot="title">
            <i :class="item.icon"></i>
            <span>{{ item.name }}</span>
          </template>
          <router-link
            v-for="(child, subIndex) in item.children"
            :key="subIndex"
            :to="child.route"
            tag="p"
          >
            <el-menu-item :index="child.index" v-if="shouldShowMenuItem(child)">
              <i :class="child.icon"></i>
              <span slot="title">{{ child.name }}</span>
            </el-menu-item>
          </router-link>
        </el-submenu>

        <!-- Else, render el-menu-item -->
        <router-link v-else :key="index" :to="item.route" tag="p">
          <el-menu-item
            :index="item.index"
            v-role="item.number"
            v-if="shouldShowMenuItem2(item)"
          >
            <i :class="item.icon"></i>
            <span slot="title">{{ item.name }}</span>
          </el-menu-item>
        </router-link>
      </template>
    </el-menu>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "asider",
  data() {
    return {
      paymentPlatform: 0,
      openeds: [],
      fullHeight: document.documentElement.clientHeight - 160,
      indexPath: "",
      sessionStorageData: {}, //门店参数集合
      isShow: false,
      search: "",
      rowList: [],
      menuList: [],
      roomList: [
        {
          name: "用户",
          route: "/role",
          index: "role",
          number: "100200",
          icon: "el-icon-user",
        },
        // {
        //   name: "隐私协议管理",
        //   route: "/memberAgreement",
        //   index: "memberAgreement",
        //   number: "100200",
        //   icon:"el-icon-user"
        // },
        // {
        //   name: "业主",
        //   route: "/landlord",
        //   index: "landlord",
        //   number: "16001",
        //   icon:"el-icon-user"
        // },
        {
          name: "项目",
          route: "/Community",
          index: "Community",
          number: "400",
          icon: "el-icon-office-building",
        },
        {
          name: "房源",
          route: "/Availability",
          index: "Availability",
          number: "500",
          icon: "el-icon-house",
        },
        // {
        //   name: "测试",
        //   route: "/Availability",
        //   index: "Availability",
        //   number: "500",
        //   icon:"el-icon-house"
        // },
        {
          name: "设备",
          route: "/equipment",
          index: "equipment",
          number: "600",
          icon: "el-icon-setting",
        },
        // {
        //   name: "房源信息导入",
        //   route: "/propertyIinformationImport",
        //   index: "propertyIinformationImport",
        //   number:'600',
        //   icon:"el-icon-setting"
        // },
        {
          name: "租约",
          route: "/rentalAgreement",
          index: "rentalAgreement",
          number: "700",
          icon: "el-icon-tickets",
        },
        {
          name: "维修",
          route: "/Repair",
          index: "Repair",
          number: "900",
          icon: "el-icon-scissors",
        },
        {
          name: "报表",
          route: "/list",
          index: "list",
          number: "1000",
          icon: "el-icon-document-copy",
        },
        // {
        //   name: "用户登陆日志",
        //   route: "/list",
        //   index: "lists",
        //   number:"4001",
        //   icon:"el-icon-document-copy"
        // },
        // {
        //   name: "水电分摊",
        //   route: "/apportion",
        //   index: "apportion",
        //   number:"2009",
        //   icon:"el-icon-document-copy"
        // },
        {
          name: "财务",
          // route: "/finance",
          index: "finance",
          number: "800",
          icon: "el-icon-money",
          children: [
            {
              name: "账单",
              icon: "el-icon-location-information",
              route: "/finance",
              number: "80021",
              index: "finance",
            },
            {
              // name: "门店中金余额",
              name: "余额",
              icon: "el-icon-location-information",
              route: "/storeBalance",
              number: "80022",
              index: "storeBalance",
            },
            // {
            //   name: "门店收款金额",
            //   icon: "el-icon-location-information",
            //   route: "/wxstoreBalance",
            //   number:"80024",
            //   index: "WxstoreBalance",
            // },
            {
              // name: "门店通联余额",
              name: "门店余额",
              icon: "el-icon-location-information",
              route: "/tlstoreBalance",
              number: "80022",
              index: "tlstoreBalance",
            },
            {
              name: "对账表",
              icon: "el-icon-location-information",
              route: "/platformCollectDetail",
              number: "80023",
              index: "platformCollectDetail",
            },
          ],
        },
        {
          name: "营运方账户",
          route: "/storeCardBinding",
          index: "storeCardBinding",
          number: "1800",
          icon: "el-icon-money",
        },
        {
          // name: "业主中金账户",
          name: "业主账户",
          route: "/landlordAccount",
          index: "landlordAccount",
          number: "1900",
          icon: "el-icon-money",
        },
        {
          // name: "业主通联账户",
          name: "业主账户",
          route: "/landlordAccountTl",
          index: "landlordAccountTl",
          number: "1900",
          icon: "el-icon-money",
        },
        {
          name: "公共配置",
          route: "/publicConfiguration",
          index: "publicConfiguration",
          number: "1100",
          icon: "el-icon-menu",
        },
        // {
        //   name: "收款审核",
        //   route: "/collectionAudit",
        //   index: "collectionAudit",
        //   number: "71001",
        //   icon:"el-icon-edit-outline"
        // },
        // {
        //   name: "租约审核",
        //   route: "/leaseAudit",
        //   index: "leaseAudit",
        //   number: "73001",
        //   icon:'el-icon-edit'
        // },
        // {
        //   name: "退租审核",
        //   route: "/refundAudit",
        //   index: "refundAudit",
        //   number: "75001",
        //   icon:"el-icon-edit"
        // },
        {
          name: "费用配置",
          route: "/publicMoney",
          index: "publicMoney",
          number: "1200",
          icon: "el-icon-set-up",
        },
        {
          name: "投诉处理",
          route: "/complain",
          index: "complain",
          number: "1700",
          icon: "el-icon-set-up",
        },
        {
          name: "损耗配置",
          route: "/publiCloss",
          index: "publiCloss",
          number: "1500",
          icon: "el-icon-set-up",
        },
        {
          name: "合同模板配置",
          route: "/contractDemo",
          index: "contractDemo",
          // number: "20001",
          number: "1400",
        },
        // {
        //   name: "企业接入",
        //   route: "/enterpriseAccess",
        //   index: "enterpriseAccess",
        //   number:""
        // }
      ],
    };
  },
  computed: {
    ...mapState(["collapse"]),
  },
  methods: {
    shouldShowMenuItem(item) {
      // 如果是"门店中金余额"且 paymentPlatform 为 '1'，则显示
      if (item.route == "/storeBalance" && this.paymentPlatform == "1") {
        return true;
      }
      // 如果是"门店通联余额"且 paymentPlatform 为 '2'，则显示
      if (item.route == "/tlstoreBalance" && this.paymentPlatform == "2") {
        return true;
      }
      if (item.route == "/wxstoreBalance" && this.paymentPlatform == "3") {
        return true;
      }
      if (item.route == "/storeCardBinding") {
        return this.paymentPlatform !== 3;
      }
      if (item.route == "/storeBalance") {
        return this.paymentPlatform !== 3;
      }
      // 对于其他项，默认显示
      if (item.name !== "门店余额") {
        return true;
      }
      // 否则，隐藏
      return false;
    },
    shouldShowMenuItem2(item) {
      // 如果是"门店中金余额"且 paymentPlatform 为 '1'，则显示
      if (item.route === "/landlordAccount" && this.paymentPlatform == "1") {
        return true;
      }
      // 如果是"门店通联余额"且 paymentPlatform 为 '2'，则显示
      if (item.route === "/landlordAccountTl" && this.paymentPlatform == "2") {
        return true;
      }
      if (item.route == "/storeCardBinding") {
        return this.paymentPlatform !== 3;
      }
      if (item.route == "/storeBalance") {
        return this.paymentPlatform !== 3;
      }
      // 对于其他项，默认显示
      if (item.name != "业主账户") {
        return true;
      }
      // 否则，隐藏
      return false;
    },
    rowClick(row) {
      if (this.rowList.length < 9) {
        let flag = true;
        this.rowList.forEach((item) => {
          if (row.index == item.index) {
            flag = false;
          }
        });
        if (flag) {
          this.rowList.push(row);
        }
      } else {
      }
    },
    handleOpen(key, keyPath) {
      sessionStorage.setItem("keyPath", key);
    },
    handleClose(key, keyPath) {
      //console.log(key, keyPath);
    },
    open(index) {
      sessionStorage.setItem("indexPath", index);
    },
    //菜单收放事件
    handleChangeCollapse(show) {
      this.$store.dispatch("actionChange", !this.collapse);
      this.isShow = !this.isShow;
    },
  },
  created() {
    var that = this;
    let menuList = [...that.menuList];
    setTimeout(() => {
      that.sessionStorageData = JSON.parse(sessionStorage.getItem("sessionStorageData"));
      that.indexPath = sessionStorage.getItem("indexPath");
      that.openeds.push(sessionStorage.getItem("keyPath"));
      menuList.forEach((item, index) => {
        if (sessionStorage.getItem("headOffice") * 1 != 1) {
          if (item.number == "900") {
            menuList.splice(index, 1);
          }
          item.menuLists.forEach((items, indexs) => {
            if (items.number == "4001200" || items.name == "角色档案") {
              item.menuLists.splice(indexs, 1);
            }
          });
        }
        item.menuLists.forEach((items) => {
          if (
            that.sessionStorageData.allowdebt == false &&
            item.number * 1 == 500 &&
            items.number * 1 == 500800
          ) {
            items.number = "0";
          }
        });
      });
      that.menuList = menuList;
    }, 1000);
  },
  mounted() {
    //console.log(document.body.clientHeight);
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    var a = document.getElementById("asider-wrapper");
    a.style.height = h - 58 + "px"; //减去顶部高度
    a.style.height = document.body.clientHeight + "px";
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    console.log("8888", userInfo);
    this.paymentPlatform = userInfo.paymentPlatform;
  },
  watch: {
    $route(to, from) {
      //监听路由 把当前路由的index存到sessionStorage 页面刷新时不该变页面   把index赋值给this.indexPath 实现路由跳转
      sessionStorage.setItem("indexPath", to.meta.index);
      this.indexPath = this.$route.meta.index;
    },
  },
};
</script>

<style scoped>
* {
  font-size: 0.9vw;
}
/deep/ .el-submenu__title span {
  font-size: 0.9vw !important;
}
/deep/.custom-submenu .el-submenu__title {
  height: 50px;
  line-height: 50px;
}

.el-menu-item,
.el-submenu__title {
  height: 50px;
  line-height: 50px;
}
/* .el-menu-item.is-active i {
  color: #a09f9f;
} */

.el-menu-vertical-demo {
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.el-menu-vertical-demo::-webkit-scrollbar {
  display: none;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-width: 64px;
  /* border-top: #5e9af5 1px solid; */
}

/* 一级菜单字体 */
.el-submenu__title span {
  /* font-size: 14px; */
  font-size: 0.75vw;
}

/* 二级菜单字体 */
.el-menu-item {
  /* font-size: 14px; */
  font-size: 0.75vw;
}

* /deep/ .el-submenu__title i {
  color: white !important;
}

/* 收缩按钮样式 */
#i i:hover {
  background: #438efd;
}

#icon i {
  color: white;
}

#icons i {
  color: white;
}

#asider-wrapper {
  max-width: 200px;
  min-width: 64px;
  min-height: 940px;
  background: rgb(48, 65, 86);
}

.el-menu {
  border: none;
}
/deep/ .el-submenu .el-menu-item {
  background-color: #304156 !important;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/asider.vue